// Stand-in for the Firebase JS SDK in @capacitor-firebase/messaging's web fallback.
// The site uses its own web push code (src/services/push.js) and only calls the plugin in the native apps,
// and the real SDK can't be parsed by this project's webpack 4.
const unavailable = () => Promise.reject(new Error('Firebase web messaging is not bundled'))

export const deleteToken = unavailable
export const getMessaging = () => { throw new Error('Firebase web messaging is not bundled') }
export const getToken = unavailable
export const isSupported = () => Promise.resolve(false)
export const onMessage = () => () => {}
